import { CardContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { ShiftDetailsInnerCard } from "../InnerCard";

export interface PostBookingDocumentsCardContentProps {
  count: number;
  onCompleteDocumentsClick: () => void;
}

export function PostBookingDocumentsCardContent(props: PostBookingDocumentsCardContentProps) {
  const { count, onCompleteDocumentsClick } = props;

  return (
    <ShiftDetailsInnerCard
      footer={
        <Button fullWidth size="medium" onClick={onCompleteDocumentsClick}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Text inline color="inherit">
              Complete {pluralize("Document", count)}
            </Text>
          </Stack>
        </Button>
      }
    >
      <CardContent>
        <Stack spacing={4} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
          <Illustration type="document-upload" />

          <Text bold variant="h4" sx={{ textAlign: "center" }}>
            Complete {count} {pluralize("document", count)}
          </Text>

          <Text variant="body1" sx={{ textAlign: "center", textWrap: "balance" }}>
            Please complete the {pluralize("document", count)} before your shift starts
          </Text>
        </Stack>
      </CardContent>
    </ShiftDetailsInnerCard>
  );
}
